import { call, takeLatest } from 'redux-saga/effects';
import * as constants from './conclusions.constants';

import * as types from './conclusions.types';
import * as services from './conclusions.saga-services';

function* invokeSetupConclusions(action: types.ISetupConclusions) {
  yield call(services.setupConclusions, action.payload);
}

function* invokeUpdateConclusionSocket(action: types.IUpdateConclusionSocket) {
  yield call(services.handleConclusionFromNotification, action.payload);
}

function* invokeSaveConclusion(action: types.ISaveConclusion) {
  yield call(services.saveConclusion, action.payload.sessionId, action.payload.userId, action.payload.conclusionData);
}

function* invokeDeleteConclusion(action: types.IDeleteConclusion) {
  yield call(services.deleteConclusion, action.payload.sessionId, action.payload.userId);
}

function* invokeDeleteConclusionSocket(action: types.IUpdateConclusionSocket) {
  yield call(services.handleDeleteConclusionFromNotification, action.payload);
}

export function* watchConclusionPageSaga() {
  yield takeLatest(constants.SETUP_CONCLUSIONS, invokeSetupConclusions);
  yield takeLatest(constants.SAVE_CONCLUSION_SOCKET, invokeUpdateConclusionSocket);
  yield takeLatest(constants.SAVE_CONCLUSION, invokeSaveConclusion);
  yield takeLatest(constants.DELETE_CONCLUSION, invokeDeleteConclusion);
  yield takeLatest(constants.DELETE_CONCLUSION_SOCKET, invokeDeleteConclusionSocket);
}
